import { GridColDef } from "@mui/x-data-grid-pro";
import { AddGeneralCodeDialog } from "components/alove/AddGeneralCodeDialog";
import { AloveDialog, DialogType } from "components/alove/AloveDialog";
import { TwoSizeChip } from "components/alove/Chips";
import { TablePage } from "components/alove/TablePage";
import { setCurrentDialog, useMaterialUIController } from "context";
import { PermissionType } from "models/BO/BoRole";
import { TagRule } from "models/events/TagRule";
import { useNavigate } from "react-router-dom";
import { camelCaseToCapitalizedWords, formatDate } from "utils/globalsUtils";
import { getTagRules, publishTagRules } from "utils/tagRuleUtils";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

export const TagRulesList = () => {
  const [controller, dispatch] = useMaterialUIController();
  const navigate = useNavigate();
  const columns: GridColDef[] = [
    {
      headerName: "Name",
      field: "name",
      flex: 1,
    },
    {
      headerName: "Key",
      field: "key",
      flex: 1,
    },
    {
      headerName: "Description",
      field: "description",
      flex: 1
    },
    {
      headerName: "Lifetime",
      field: "taggedExpirationDays",
      flex: 1,
      renderCell: (params) => {
        const days = params.value;
        return days ? `${days} days` : '-';
      },
    },
    {
      headerName: "Status",
      field: "status",
      flex: 1,
      renderCell: (params) => {
        const tagRule:TagRule = Object.assign(new TagRule(), params.row);
        return  <TwoSizeChip label={tagRule.statusLabel} color={tagRule.statusColor as any} />;
      },
    },
    {
      headerName: "Created",
      field: "created",
      flex: 1,
      valueGetter: (v) => formatDate(v)
    }
  ];

  const loadTagRules = () => getTagRules();

  return (
    <DashboardLayout>
      <DashboardNavbar pageTitle="Tag Rules" />
      <TablePage
        actions={{
          title: "Rules actions",
          addActions: [
            {
              label: "Rule",
              onClick: () => navigate("/tagRules/new"),
              variant: "contained",
              color: "secondary",
            }
          ],
        }}
        table={{
          loadNext: loadTagRules,
          columns,
          lineClick: (tagRule) => !isNaN(tagRule.id) && navigate(`/tagRules/${tagRule.id}`),
          
        }}
        title="TagRules"
      />
    </DashboardLayout>
  );
};
